module.exports = __webpack_public_path__ + "static/media/sf-test-3.599ac620.mp3";